<template>
    <button :class="buttonClassName" @click="clicked" :disabled="disabled">
        <v-loader v-if="loading || submitted"></v-loader>
        <slot></slot>
    </button>
</template>

<script>

    import Loader from './../_Partials/Loader';
    import mixin from './button-mixin.js';

    export default {
        components: {
            'v-loader': Loader
        },
        mixins: [mixin]
    }
</script>
